export default __webpack_public_path__ + "static/media/image11.6241e5fe.jpg";